import PropTypes from 'prop-types'

// This file contains all filter helper functions
// for queries with the form allWp{PostType}

/**
 * Filters list of CTA custom posts to return one
 *
 * @param {Array} ctaArr - CPT 'allWpCta' nodes
 * @param {String} titleString - title attr of desired CTA
 *
 * @returns {Object} - single CTA object to be passed to component
 */
export const filterCtaData = (ctaArr, titleString) => {
  const filtered = ctaArr.filter(data =>
    data?.title.toLowerCase().includes(titleString),
  )

  return filtered.shift()
}

filterCtaData.propTypes = {
  ctaArr: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      cta: PropTypes.shape({
        backgroundImage: PropTypes.shape({
          altText: PropTypes.string,
          sourceUrl: PropTypes.string,
        }),
        header: PropTypes.string,
        content: PropTypes.string,
        icon: PropTypes.shape({
          altText: PropTypes.string,
          sourceUrl: PropTypes.string,
        }),
        link: PropTypes.shape({
          text: PropTypes.string,
          page: PropTypes.object,
        }),
      }),
    }),
  ),
  titleString: PropTypes.string,
}

/**
 * Filters list of CTA custom posts to return one
 *
 * @param {Object} originalPost - WpPost Object, the main post of the postTemplate
 * @param {Array} nextPosts - All Posts where id !== originalPost.id, chronological
 * @param {Boolean} filter - Selects which post from array, rough draft example
 *
 * @returns {Object} - Single post object to be passed to PostSingle component
 */
export const filterPostsByCat = (orignalPost, nextPosts, first = true) => {
  const catFilter = post => post.categories?.cats[0]['name']

  const filtered = nextPosts.filter(
    data => catFilter(data) === catFilter(orignalPost),
  )


  // Basic example of possible post selection from array at filter level
  if (first) {
    return filtered[0]
  } else {
    return filtered
  }
}
